import { FunctionComponent } from "react";

import { InlinePanelColorMap, InlinePanelColor } from "../../../InlinePanel/InlinePanel.types";

import styles from "./ExchangeInlineReceiptPanel.web.css";
import { ExchangeUnmatchedCard } from "../ExchangeUnmatchedCard/ExchangeUnmatchedCard.web";
import { ExchangeMatchedCard } from "../ExchangeMatchedCard/ExchangeMatchedCard.web";
import { ExchangeInlineReceiptPanelViewModel } from "./ExchangeInlineReceiptPanel.types";
import { InlinePanel } from "../../../InlinePanel/InlinePanel.web";

export const ExchangeInlineReceiptPanel: FunctionComponent<ExchangeInlineReceiptPanelViewModel> = ({
  title,
  side,
  matched,
  unmatched,
  onDone,
  onBetWithMatchMe,
  onCancel,
  onEdit,
  shouldDisplayBetWithMatchMe,
  isLineBettingType,
}) => (
  <InlinePanel
    title={title}
    titlePrefix={matched?.titlePrefix || unmatched?.titlePrefix}
    color={isLineBettingType ? InlinePanelColor.Green : InlinePanelColorMap[side]}
    onAction={onDone}
  >
    {!!unmatched && (
      <div className={styles.placedBet}>
        <ExchangeUnmatchedCard
          {...unmatched}
          onBetWithMatchMe={onBetWithMatchMe}
          onCancel={onCancel}
          onEdit={onEdit}
          shouldDisplayBetWithMatchMe={shouldDisplayBetWithMatchMe}
        />
      </div>
    )}
    {!!matched && (
      <div className={styles.placedBet}>
        <ExchangeMatchedCard {...matched} />
      </div>
    )}
  </InlinePanel>
);
